/*
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-07-22 12:00:59
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\ultrasonicDetail.js
 */

import request from '@/utils/request'
import config from '@/utils/config'

/**
 * 编辑单个帖子详情
 *
 * @param {*} data
 */
export function updateForums(data) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/Update',
    method: 'post',
    data
  })
}

/**
 * 查询单个帖子详情
 *
 * @param {*} params
 */
export function getOne(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/One',
    method: 'get',
    params
  })
}

/**
 * 查询单个帖子图片影像数据
 *
 * @param {*} params
 */
export function getForumFileList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/One/ForumFile/List',
    method: 'get',
    params
  })
}

/**
 * 删除单个帖子图片影像数据
 *
 * @param {*} params
 */
export function deleteForumFile(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumFile/Delete',
    method: 'delete',
    params
  })
}

/**
 * 查询单个帖子所有评论
 *
 * @param {*} params
 */
export function getForumCommentList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumComment/List',
    method: 'get',
    params
  })
}

/**
 * 查询单个帖子所有评论回复
 *
 * @param {*} params
 */
export function getReplyCommentList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumComment/Reply/List',
    method: 'get',
    params
  })
}

/**
 * 删除单个帖子评论
 *
 * @param {*} params
 */
export function deleteOrBackComment(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumComment/DeleteOrBack',
    method: 'delete',
    params
  })
}

/**
 * 后台超人圈帖子附件添加
 *
 * @param {*} params
 */
export function addForumAccessory(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/Accessory/Add',
    method: 'post',
    data:params
  })
}

/**
 * 后台超人圈帖子附件删除
 *
 * @param {*} params
 */
export function deleteForumAccessory(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminForums/ForumAccessory/Delete',
        method: 'delete',
        params
    })
}

/**
 * 后台获取指定超人圈帖子附件集合信息
 *
 * @param {*} params
 */
export function getForumAccessoryList(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminForums/One/ForumAccessory/List',
        method: 'get',
        params
    })
}
